<template>
  <div class="slide-library-video-modal">
    <b-modal
      v-model="showModal"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      title="Case Videos"
      @hidden="handleHidden"
    >
      <div v-if="selectedCase" class="case-detail mb-3">
        <span class="fw-600 text-primary">{{ $t("common.caseNumber") }}:</span>
        <span class="pl-1">{{ selectedCase.systemCaseNumber || selectedCase.caseNumber || "--" }}</span>
      </div>

      <div v-if="isLoading" class="loading-state">
        <b-spinner variant="primary" class="mr-2"></b-spinner>
        <span>Loading videos...</span>
      </div>

      <div v-else>
        <div class="form-group">
          <label>Treatment Videos</label>
          <p-dropdown
            v-model="selectedTreatmentVideoId"
            :options="treatmentVideos"
            optionLabel="headline"
            optionValue="id"
            placeholder="Select Treatment Video"
            class="p-dropdown-custom form-control form-control-sm"
            aria-label="Treatment Videos"
            aria-labelledby="Treatment Videos"
            :disabled="!treatmentVideos.length"
            :showClear="true"
          />
          <small v-if="!treatmentVideos.length" class="text-muted d-block pt-1">
            No treatment videos available
          </small>
        </div>

        <div class="form-group">
          <label>{{ $t("common.diagnosis") }} Videos</label>
          <p-dropdown
            v-model="selectedDiagnosisVideoId"
            :options="diagnosisVideos"
            optionLabel="headline"
            optionValue="id"
            :placeholder="`Select ${$t('common.diagnosis')} Video`"
            class="p-dropdown-custom form-control form-control-sm"
            :aria-label="`${$t('common.diagnosis')} Videos`"
            :aria-labelledby="`${$t('common.diagnosis')} Videos`"
            :disabled="!diagnosisVideos.length"
            :showClear="true"
          />
          <small v-if="!diagnosisVideos.length" class="text-muted d-block pt-1">
            No {{ $t("common.diagnosis").toLowerCase() }} videos available
          </small>
        </div>

        <div class="text-right pb-0">
          <b-col class="d-flex justify-content-end align-items-baseline">
            <div v-if="isSaving" class="loading-state" style="min-height:auto">
                <wtr-loader
                  class="mr-3 text-primary"
                  loadingText=" Wait..."
                  addText
                ></wtr-loader>
              </div>
            <b-btn
              aria-label="cancel"
              aria-labelledby="cancel"
              variant="outline-primary"
              size="sm"
              class="mr-2"
              v-on:click="cancel"
            >
              {{ $t("common.cancel") }}
            </b-btn>
            <b-btn
              aria-label="save"
              aria-labelledby="save"
              variant="primary"
              size="sm"
              v-on:click="saveSelection"
            >
              {{ $t("common.save") }}
            </b-btn>
          </b-col>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "slide-library-video-modal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isSaving: {
      type: Boolean,
      default: false,
    },
    selectedCase: {
      type: Object,
      default: null,
    },
    videos: {
      type: Object,
      default: () => ({
        treatmentVideos: [],
        diagnosisVideos: [],
      }),
    },
  },
  data() {
    return {
      showModal: false,
      selectedTreatmentVideoId: null,
      selectedDiagnosisVideoId: null,
    };
  },
  computed: {
    treatmentVideos() {
      return this.videos?.treatmentVideos || [];
    },
    diagnosisVideos() {
      return this.videos?.diagnosisVideos || [];
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(value) {
        this.showModal = value;
        if (value) {
          this.setSelectionsFromCase();
        }
      },
    },
    selectedCase: {
      immediate: true,
      handler() {
        if (this.showModal || this.show) {
          this.setSelectionsFromCase();
        }
      },
    },
  },
  methods: {
    resetSelections() {
      this.selectedTreatmentVideoId = null;
      this.selectedDiagnosisVideoId = null;
    },
    setSelectionsFromCase() {
      this.selectedTreatmentVideoId =
        this.selectedCase?.treatmentVideoId || this.selectedCase?.treatmentVideo?.id || null;
      this.selectedDiagnosisVideoId =
        this.selectedCase?.diagnosisVideoId || this.selectedCase?.diagnosisVideo?.id || null;
    },
    cancel() {
      this.showModal = false;
    },
    saveSelection() {
      this.$emit("save", {
        treatmentVideoId: this.selectedTreatmentVideoId,
        diagnosisVideoId: this.selectedDiagnosisVideoId,
        treatmentVideo: this.findSelectedVideo(this.treatmentVideos, this.selectedTreatmentVideoId),
        diagnosisVideo: this.findSelectedVideo(this.diagnosisVideos, this.selectedDiagnosisVideoId),
      });
    },
    handleHidden() {
      this.resetSelections();
      this.$emit("close");
    },
    findSelectedVideo(videoList, videoId) {
      return videoList.find((item) => item.id === videoId) || null;
    },
  },
};
</script>

<style scoped>
.loading-state {
  min-height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.case-detail {
  font-size: 14px;
}
</style>
